import {Component} from '@angular/core';
import {SpinnerComponent} from '../../../utils/spinner/spinner.component';
import {AConcreteResource} from '../../../AConcreteResource';
import {ApiInterfaceModel} from '../../../../models/resources/api-interface.model';
import {Router, RouterOutlet} from '@angular/router';
import {ApiInterfaceService} from '../../../../services/resources/api-interface.service';
import {BtnGroupNavComponent} from "../../../utils/btn-group-nav/btn-group-nav.component";
import {SubPageModel} from "../../../../models/sub-page.model";

@Component({
  selector: 'app-api-interface',
  imports: [
    SpinnerComponent,
    BtnGroupNavComponent,
    RouterOutlet
  ],
  templateUrl: './api-interface.component.html',
  styleUrl: './api-interface.component.scss'
})
export class ApiInterfaceComponent extends AConcreteResource<ApiInterfaceModel> {
  pages: SubPageModel[] = [
    {
      value: 'DATA',
      link: '.',
      isBasePage: true,
      icon: 'fas fa-info-circle'
    },
    {
      value: 'NAVIGATION.CUSTOMERS',
      link: 'customers',
      icon: 'fas fa-users'
    }
  ];
  activePage: SubPageModel = this.pages[0];

  constructor(router: Router, apiInterfaceService: ApiInterfaceService) {
    super(router, apiInterfaceService);
  }
}
